import React from "react";
import { useDispatch } from "react-redux";
import { actions as modalActions } from "@gc-npm/reducers.modals-reducer";
import { COLORS } from "@gc-npm/utils.enums.colors";
import ShoppingCart900 from "@/components/ShoppingCart/ShoppingCart900";
import Button, { BUTTON_WIDTH } from "@gc-npm/components.button";
const ShoppingCartFooterConfigMobileFlyOut = (props) => {
  const { buttonTextMobileConfirmation, taggingInfo, onClick, stateProps } = props;
  const { isLoading } = stateProps;
  const dispatch = useDispatch();

  const onclickHandler = () => {
    // dispatch(modalActions.addModal({ id: "" }));
    onClick();
  };

  return (
    <>
      <div className="ShoppingCartFooterConfigMobileFlyOut">
        <div className="content">
          <Button
            label={buttonTextMobileConfirmation}
            onClick={onclickHandler}
            taggingInfo={{...taggingInfo, componentContent: buttonTextMobileConfirmation}}
            width={BUTTON_WIDTH.FULL}
            disabled={isLoading}
          />
          <ShoppingCart900 button={true} />
        </div>
      </div>
      <style jsx>
        {`
          .ShoppingCartFooterConfigMobileFlyOut {
            position: fixed;
            z-index: 30;
            bottom: 0px;
            left: 0px;
            width: 100%;
            background-color: ${COLORS.grey100};
            border-top: 2px solid ${COLORS.grey200};
            padding: 0.75rem 1rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            min-height: 74px;
            gap: 8px;
            .content {
              width: 100%;
              display: flex;
              flex-direction: row;
              gap: 1rem;
            }
          }
        `}
      </style>
    </>
  );
};

export default ShoppingCartFooterConfigMobileFlyOut;
